<template>
  <CustomerAttributePills :attributes="attributes" location="compactProfileCard" class="gmf-customer-pills" :maxLines="2" />
</template>

<script>
import state from '@/state';
import CustomerAttributePills from '@/components/CustomerAttributePills.vue';

export default {
  components: {
    CustomerAttributePills,
  },
  name: 'MyCustomerPills',
  data () {
    return {
      state,
    };
  },
  computed: {
    profile() {
      return this.state.profile;
    },
    attributes () {
      return this.profile.attributesJson ? JSON.parse(this.profile.attributesJson) : null;
    },
  },
};
</script>
